import { Link, Outlet } from 'react-router-dom';
import { isServiceEnabled } from '@formosa/shared/constants/serviceGate';

const SERVICE_LABELS = {
  order: '交易',
  payment: '入出金與錢包',
  market: '行情',
  im: '聊天',
};

/**
 * 服務停用時的明確提示頁（REACT_APP_DISABLED_SERVICES）。
 * 不轉址、不呼叫任何 API；只提供返回首頁。
 */
export function FeatureUnavailable({ service }) {
  const label = SERVICE_LABELS[service] || '此功能';
  return (
    <section className="feature-unavailable" data-testid="feature-unavailable" data-service={service}>
      <h2>{label}功能尚未開放</h2>
      <p>此功能於目前環境未啟用。</p>
      <Link to="/">返回首頁</Link>
    </section>
  );
}

/**
 * 依 build-time 服務開關守衛路由：服務停用時不渲染子頁面（避免頁面載入即呼叫未部署服務）。
 * @param {{ service: 'order'|'payment'|'market'|'im' }} props
 */
export default function ServiceRoute({ service }) {
  if (!isServiceEnabled(service)) {
    return <FeatureUnavailable service={service} />;
  }
  return <Outlet />;
}
